/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser'

import { TEMP_LOG_FUNCTION } from './api/auth'

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: Address unused variable
const DIDGE_FRONT_END_CLIENT_ID = '6be268b7-2121-4b4c-b671-6b5964febd76'
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: Address unused variable
const DIDGE_BACK_END_CLIENT_ID = '27c8e0c9-937d-4a36-8aba-29311a00faf3'
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: Address unused variable
const NEXTERA_TENANT_ID = '2d40ea96-5fa2-4332-89a8-daeb52af54b5'

const SKANSKA_FRONT_END_CLIENT_ID = '06595204-3dbb-4dc0-9151-8d3736df7d3a'
const SKANSKA_BACK_END_CLIENT_ID = 'cecd57f0-68f4-46dc-9353-69c2ec088cd9'
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: Address unused variable
const SKANSKA_TENANT_ID = '33dab507-5210-4075-805b-f2717d8cfa74'

export const msalConfig = {
  auth: {
    clientId: SKANSKA_FRONT_END_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
    authority: `https://login.microsoftonline.com/organizations`, // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: '/redirect', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper message type
      loggerCallback: (level: LogLevel, message: any, containsPii: boolean) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
            console.error(message)
            TEMP_LOG_FUNCTION(message)
            return
          case LogLevel.Info:
            // eslint-disable-next-line no-console -- TODO: Replace with proper logging
            console.info(message)
            TEMP_LOG_FUNCTION(message)
            return
          case LogLevel.Verbose:
            // eslint-disable-next-line no-console -- TODO: Replace with proper logging
            console.debug(message)
            TEMP_LOG_FUNCTION(message)
            return
          case LogLevel.Warning:
            // eslint-disable-next-line no-console -- TODO: Replace with proper logging
            console.warn(message)
            TEMP_LOG_FUNCTION(message)
            return
          default:
            return
        }
      },
    },
  },
}

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  nexteraApi: {
    endpoint: 'http://localhost:5000/api/todolist',
    scopes: {
      use: [`api://${SKANSKA_BACK_END_CLIENT_ID}/NexteraApi.Use`],
    },
  },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [...protectedResources.nexteraApi.scopes.use],
}

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
  scopes: ['openid', 'profile'],
  loginHint: 'example@domain.net',
}

//
